import React,{useState} from 'react';
import { Button,Alert  } from 'react-bootstrap';

function AlertDismissibleExample(props) {

  const [show, setShow] = useState(false);

    if (props.state) {
      return (
        <Alert variant="danger">
          <Alert.Heading>!אוי לא יש לך טעות</Alert.Heading>
          <p>
      {props.msg}
          </p>
        </Alert>
      );
    }
return <div>{props.state}</div>;
  }
  export default AlertDismissibleExample;